import Term from "../term/Term";
import { LearningType } from "./LearningType";

export default class LearningRetry {
  terms: Term[];
  type: LearningType;

  constructor(terms: Term[], type: LearningType) {
    this.terms = terms;
    this.type = type;
  }
}
